import { lazy, Suspense } from 'react';
import { Spinner } from "../Loader/Spinner";

export const Loader = () => (
    <div className="d-flex align-items-center justify-content-center vh-100">
        <Spinner/>
    </div>
)

export const loadable = (importFunc, fallback = <Loader/>) => {
    const LazyComponent = lazy(importFunc);
    return (props) => (
        <Suspense fallback={fallback}>
            <LazyComponent {...props} />
        </Suspense>
    );
};